import ElevatedPaper, {
  DEFAULT_STYLE,
} from "../../../../../components/ElevatedPaper";
import Flex from "../../../../../components/Flex";
import EducationMaterialTable from "../../../../../components/app/provider/lib/education-material/EducationMaterialTable";
import { DobAuthProvider } from "../DobAuthProvider";

const PublicViewEducationMaterialList = () => {
  return (
    <Flex
      height="calc(100vh - 8px)"
      width="100svw"
      flexDirection={{ xs: "column", sm: "row" }}
    >
      {/* patient side bar */}
      <DobAuthProvider>
        <ElevatedPaper
          sx={{
            ...DEFAULT_STYLE,
            minHeight: "calc(100vh - 2rem)",
            padding: 2,
            width: "100%",
          }}
        >
          <EducationMaterialTable
            isPublicView
            shouldAction={false}
            setFilter={() => {}}
          />
        </ElevatedPaper>
      </DobAuthProvider>
    </Flex>
  );
};

export default PublicViewEducationMaterialList;
